import { Component, OnInit, Input, Output, EventEmitter, AfterViewChecked, AfterViewInit, ViewChild, ElementRef } from '@angular/core';

import * as State from '@shared/state';

@Component({
    selector: 'shared-cart-items',
    templateUrl: './cart-items.shared.component.html',
    styleUrls: ['./cart-items.shared.component.scss']
})
export class CartItemsComponent implements OnInit, AfterViewChecked, AfterViewInit {
    private _init: boolean = false;
    private _hasScroll: boolean = false;

    @Input() public cartItems: Array<State.ICartMenuFlow | State.ICartSimpleItem>;
    @Input() public maxHeight: number = null;
    @Output() public onScrollInit: EventEmitter<HTMLElement> = new EventEmitter();
    @Output() public onScrollY: EventEmitter<HTMLElement> = new EventEmitter();
    @Output() public onScrollToggle: EventEmitter<boolean> = new EventEmitter(true);
    @ViewChild('container', { static: false }) public container: ElementRef;
    @ViewChild('itemsList', { static: false }) public itemsList: ElementRef;

    constructor() { }

    ngOnInit(): void { }

    ngAfterViewInit(): void {
        this._init = true;
    }

    ngAfterViewChecked(): void {
        setTimeout(() => {
            if (this._init) {

                if (this.container?.nativeElement && this.itemsList?.nativeElement) {
                    const isScrolling: boolean = this.container.nativeElement.clientHeight < this.itemsList.nativeElement.clientHeight;

                    if (isScrolling !== this._hasScroll) {
                        this._hasScroll = isScrolling;
                        this.onScrollToggle.emit(this._hasScroll);
                    }
                }

            }
        }, 0);
    }

    public handleScrollInit($event: HTMLElement): void {
        this.onScrollInit.emit($event);
    }

    public handleScrollY($event: HTMLElement): void {
        this.onScrollY.emit($event);
    }

    public trackBy(index: number, cartItem: State.ICartMenuFlow | State.ICartSimpleItem): number {
        return cartItem._Id;
    }
}
